(function () {
  function fmtMoney(amount, currency) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(Math.round(amount * 100), Shopify.money_format);
      }
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(amount);
    } catch (e) { return '$' + (amount || 0).toFixed(2); }
  }

  function getSelectedVariant(PRODUCT) {
    var idEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = idEl ? Number(idEl.value) : (PRODUCT.variants[0] && PRODUCT.variants[0].id);
    return PRODUCT.variants.find(function (v) { return v.id == id; }) || PRODUCT.variants[0];
  }

  function pickBucket(buckets, price) {
    for (var i = 0; i < buckets.length; i++) {
      var b = buckets[i];
      if (price >= b.min && price <= b.max) return b;
    }
    return buckets[buckets.length - 1];
  }

  async function loadMapping(url) {
    const res = await fetch(url, { cache: 'no-store' });
    if (!res.ok) throw new Error('Cannot load mapping JSON: ' + res.status);
    return await res.json();
  }

  const DEFAULT_DETAILS_HTML = `
    <div class="jmcp-modal__body-inner">
      <h2>Protect your jewelry</h2>
      <p>Your jewelry tells a story, and we’re here to help it last. Wear your jewelry worry-free knowing your jewelry is covered for routine maintenance and protected from accidental damage. Available with a lifetime, 5 years, or 3 years care plan.</p>

      <h3>This plan covers:</h3>
      <ul>
        <li>Hassle-free repair or replacements</li>
        <li>Accidental damage and normal maintenance</li>
        <li>Loss of center or side stones due to damage</li>
        <li>Insured shipping to and from Rare Carat for claims service, at no cost to you</li>
      </ul>

      <h3>Why choose JM® Care Plan?</h3>
      <ul>
        <li>Simple claims process</li>
        <li>No hidden fees. No deductibles.</li>
      </ul>
    </div>
  `;

  function renderCard(container, cfg, PRODUCT) {
    const v = getSelectedVariant(PRODUCT);
    const price = (v.price || PRODUCT.price) / 100;
    const bucket = pickBucket(cfg.buckets, price);
    const lifetime = bucket.lifetime, three = bucket.three_year;
    const currency = cfg.currency || window.JMCP?.CURRENCY || 'USD';

    container.innerHTML = `
      <div class="jmcp-card" id="jmcp-card">
        <div class="jmcp-head">
          <div class="jmcp-brand">${cfg.brand_label || 'JM CARE PLAN'}</div>

          <div class="jmcp-row">
            <div class="jmcp-left">
              <div class="jmcp-title" id="jmcp-headline">Protect Your Jewelry For Life</div>
              <div class="jmcp-sub">Enjoy lifetime service with a one-time purchase</div>

              <div class="jmcp-planpicker">
                <label><input type="radio" name="jmcp-plan" value="lifetime" checked> Lifetime</label>
                <label><input type="radio" name="jmcp-plan" value="three"> 3 Years</label>
              </div>

              <!-- Reviews slot (we'll inject Liquid-rendered HTML here) -->
              <div class="jmcp-reviews" id="jmcp-reviews-slot" style="display:none"></div>
            </div>

            <div class="jmcp-right">
              <div class="jmcp-price" id="jmcp-price"></div>
              <button class="jmcp-cta" id="jmcp-add">Add Plan</button>
            </div>
          </div>
        </div>

        <table class="jmcp-table">
          <thead><tr><th>Service Needed</th><th>Typical Cost</th><th>With This Plan</th></tr></thead>
          <tbody>
            <tr><td>Prong/Stone Tightening</td><td>$36–$54+</td><td>INCLUDED</td></tr>
            <tr><td>Repair Damaged Mounting</td><td>$250–$460+</td><td>INCLUDED</td></tr>
            <tr><td>Ring Sizing</td><td>$58–$215+</td><td>INCLUDED</td></tr>
            <tr><td>Free One-Time Engraving</td><td>$35.99+</td><td>INCLUDED</td></tr>
          </tbody>
        </table>

        <div class="jmcp-foot">
          <a href="${cfg.details_page_url || '/pages/jm-care-plan-details'}" id="jmcp-details-link">See protection plan details</a>
        </div>

        <!-- Modal -->
        <div class="jmcp-modal" id="jmcp-modal" hidden>
          <div class="jmcp-modal__overlay" id="jmcp-close"></div>
          <div class="jmcp-modal__content">
            <button type="button" class="jmcp-modal__x" id="jmcp-close-x" aria-label="Close">×</button>
            <div id="jmcp-modal-body" class="jmcp-modal__body"></div>
          </div>
        </div>
      </div>
    `;

    function currentPlan() {
      const val = (container.querySelector('input[name="jmcp-plan"]:checked') || {}).value || 'lifetime';
      return val === 'three' ? three : lifetime;
    }

    function updatePrice() {
      const p = currentPlan();
      container.querySelector('#jmcp-price').textContent = fmtMoney(p.price, currency);
      container.querySelector('#jmcp-headline').textContent =
        (p === lifetime) ? 'Protect Your Jewelry For Life' : 'Protect Your Jewelry for 3 Years';
    }

    updatePrice();
    container.querySelectorAll('input[name="jmcp-plan"]').forEach(r => r.addEventListener('change', updatePrice));

    // re-pick bucket when variant changes
    const idEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idEl) idEl.addEventListener('change', () => renderCard(container, cfg, PRODUCT));

    // add to cart with correct variant (must exist in JSON mapping)
    container.querySelector('#jmcp-add').addEventListener('click', async function () {
      const p = currentPlan();
      if (!p.variant_id) { alert('Care Plan variants not configured yet.'); return; }
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: p.variant_id, quantity: 1, properties: { _jm_for_product: PRODUCT.id } })
      });
      location.reload();
    });

    // inject reviews (copied from hidden Liquid source)
    const src = document.getElementById('jmcp-reviews-src');
    const slot = container.querySelector('#jmcp-reviews-slot');
    if (src && slot && src.innerHTML.trim()) {
      slot.innerHTML = src.innerHTML;
      slot.style.display = 'block';
    }

    // Modal: load page HTML, then remove any "See full details" link or links back to products
    const detailsA = container.querySelector('#jmcp-details-link');
    const modal   = container.querySelector('#jmcp-modal');
    const modalBody = container.querySelector('#jmcp-modal-body');

    detailsA.addEventListener('click', async (e) => {
      e.preventDefault();
      const url = detailsA.getAttribute('href');
      try {
        const resp = await fetch(url, { credentials: 'same-origin' });
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        const html = await resp.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('main .rte, .rte, .shopify-policy__body, main') || doc.body;
        modalBody.innerHTML = content.innerHTML;

        // remove the inner "See full details" or any links back to products
        Array.from(modalBody.querySelectorAll('a')).forEach(a => {
          const txt = (a.textContent || '').trim();
          const href = (a.getAttribute('href') || '');
          if (/see full details/i.test(txt) || /\/products\//i.test(href)) a.remove();
        });
      } catch (err) {
        modalBody.innerHTML = DEFAULT_DETAILS_HTML; // fallback content
      }
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    });

    modal.addEventListener('click', (ev) => {
      if (ev.target.id === 'jmcp-close' || ev.target.id === 'jmcp-close-x') {
        modal.setAttribute('hidden','hidden');
        document.body.style.overflow = '';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', async function () {
    try {
      const root = document.getElementById('jm-careplan-root');
      if (!root || !window.JMCP || !window.JMCP.PRODUCT) return;

      const cfg = await loadMapping(window.JMCP.MAPPING_URL);
      if (!cfg.currency && window.JMCP.CURRENCY) cfg.currency = window.JMCP.CURRENCY;

      if (cfg.show_on_protectable_only) {
        const tags = (window.JMCP.PRODUCT.tags || []);
        const hasTag = Array.isArray(tags) ? tags.includes('protectable') : ('' + tags).indexOf('protectable') >= 0;
        if (!hasTag) return;
      }

      renderCard(root, cfg, window.JMCP.PRODUCT);
    } catch (e) {
      console.error('[JMCP] init error:', e);
    }
  });
})();
